import DataSource from "devextreme/data/data_source";
import { useQuery } from "react-query";
import { atom, atomFamily } from "recoil";
import { loadFn, Params } from "shared/component/dxf-map/dxf-map";
import { client } from "shared/helpers/client";



export const getBalanceOffice=(params: Params)=> {
  return client<any[]>('/OwnerBooking/GetOfficeBalance', { params })
}

export const BalanceOfficeSource = (officeId: number) => new DataSource({
    key:"id",
    load:loadFn(getBalanceOffice,{officeId})
  })

  export const BalanceOfficeSourceAtom = atomFamily({
    key: 'BalanceOfficeSource',
    default: (officeId: any) => BalanceOfficeSource(officeId),
    dangerouslyAllowMutability:true
    })
    